import { forwardRef } from "@wordpress/element";
import { styled } from "goober";

export const PreviewFrame = styled("iframe", forwardRef)`
  display: block;
  border: none;
  pointer-events: none;
  width: 100%;
`;

export const Container = styled("div")``;

export const BrandedLink = styled("a")`
  pointer-events: none !important;
  display: block;
`;
